<template>
    <div id="ResearchProfile">
        <div class="card">
            <div class="card-body">
                <div class="d-flex align-items-center mb-4">
                    <h5 class="card-title flex-grow-1 mb-0">Research Profile</h5>
                </div>
                <CommonSpinner v-if="isLoading" />
                <div v-else class="row g-4">
                    <div v-if="profile" class="col-12">
                        <div class="card border mb-0">
                            <div class="card-body p-3">
                                <div class="row g-4">

                                    <div class="col-lg-7">
                                        <div class="d-flex justify-content-between mb-3">
                                            <h5 class="mb-0">{{ profile.specialization }}</h5>

                                            <div class="dropdown dropstart no-arrow">
                                                <button class="dropdown-toggle btn btn-sm rounded-circle btn-primary" type="button" data-bs-toggle="dropdown">
                                                    <i class="ri-more-2-fill"></i>
                                                </button>
                                                <ul class="dropdown-menu">
                                                    <li>
                                                        <button @click.prevent="openEditView(profile)" class="dropdown-item">
                                                            Edit
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="mb-4">
                                            <h6 class="text-muted">Research Interests</h6>
                                            <p class="mb-0">{{ profile.research_interests || 'Not provided' }}</p>
                                        </div>

                                        <div class="table-responsive">
                                            <table class="table table-sm table-borderless align-middle mb-0">
                                                <tbody>
                                                    <tr>
                                                        <th width="180">ORCID</th>
                                                        <td>{{ profile.orcid || '-' }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Google Scholar</th>
                                                        <td>{{ profile.google_scholar || '-' }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Scopus Author ID</th>
                                                        <td>{{ profile.scopus_author_id || '-' }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Web of Science ID</th>
                                                        <td>{{ profile.web_of_science_id || '-' }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>ResearchGate</th>
                                                        <td>{{ profile.research_gate || '-' }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="col-lg-5">
                                        <div class="row g-3">

                                            <div class="col-6">
                                                <div class="border rounded text-center p-3">
                                                    <h3 class="mb-1">{{ profile.total_publications || 0 }}</h3>
                                                    <small class="text-muted">Publications</small>
                                                </div>
                                            </div>

                                            <div class="col-6">
                                                <div class="border rounded text-center p-3">
                                                    <h3 class="mb-1">{{ profile.total_citations || 0 }}</h3>
                                                    <small class="text-muted">Citations</small>
                                                </div>
                                            </div>

                                            <div class="col-6">
                                                <div class="border rounded text-center p-3">
                                                    <h3 class="mb-1">{{ profile.h_index || 0 }}</h3>
                                                    <small class="text-muted">h-index</small>
                                                </div>
                                            </div>

                                            <div class="col-6">
                                                <div class="border rounded text-center p-3">
                                                    <h3 class="mb-1">{{ profile.i10_index || 0 }}</h3>
                                                    <small class="text-muted">i10-index</small>
                                                </div>
                                            </div>

                                            <div class="col-4">
                                                <div class="border rounded text-center p-3">
                                                    <h3 class="mb-1">{{ profile.research_grants || 0 }}</h3>
                                                    <small class="text-muted">Grants</small>
                                                </div>
                                            </div>

                                            <div class="col-4">
                                                <div class="border rounded text-center p-3">
                                                    <h3 class="mb-1">{{ profile.awards || 0 }}</h3>
                                                    <small class="text-muted">Awards</small>
                                                </div>
                                            </div>

                                            <div class="col-4">
                                                <div class="border rounded text-center p-3">
                                                    <h3 class="mb-1">{{ profile.patents || 0 }}</h3>
                                                    <small class="text-muted">Patents</small>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!profile" class="text-center">
                        <h4 class="mt-4 mb-2">No research profile added.</h4>
                        <p class="text-muted mb-4">
                            You have not added your research profile yet.
                        </p>
                        <button @click="formContext.modal = true" class="btn btn-primary" type="button">
                            Add Research Profile
                        </button>
                    </div>
                </div>
               
            </div>
        </div>
        <b-modal
            v-model="formContext.modal"
            size="lg"
            centered
            hide-footer
            title-class="fs-6"
            :title="formContext.editMode ? 'Update Research Profile' : 'Add Research Profile'"
            @hide="closeEditView()">

            <research-profile-form
                v-if="formContext.modal"
                :edit-mode="formContext.editMode"
                :edit-item="formContext.item"
                @closeMe="closeEditView()"
                @addedItem="addItem"
                @updatedItem="updateItem"/>

        </b-modal>
    </div>
</template>

<script>
import ResearchProfileForm from "@/components/forms/ResearchProfileForm.vue";
import { commonEditViewMixin } from "@/mixins/commonEditViewMixin";

export default {
    components:{
        ResearchProfileForm,
    },
    mixins:[commonEditViewMixin],
    data(){
        return{
            isLoading:false,
            profile:null
        }
    },
    methods:{
        addItem(item){
            this.profile.unshift(item);
        },
        updateItem(item){
            Object.assign(this.profile, item);
        },
        fetchItems(){
            this.isLoading=true;
            this.$http.get("/research-profiles")
            .then(response => {
                this.isLoading=false;
                if(response.data.success){
                    this.profile = response.data.data;
                }
            });
        }
    },
    created(){
        this.fetchItems();
    }
}
</script>